import * as yup from 'yup';

import validateLoanAmount from './validateLoanAmount';

export const loanRequestDetailsSchema = yup.object().shape({
    amount: validateLoanAmount
});
